import { RefObject } from "react";
import { useWindowDimensions } from "../../../../customeHooks/useWindowDimensions";
import {
  sendSupportEmail,
  sendWhatsappMessage,
} from "../../../../utils/helpers";
import { Button, ButtonVariations } from "../../../buttons/button";
import { PopoverMenu } from "../../../dropdown/popover";
import { Icon } from "../../../icon/icon";

const HelpChannel = ({
  svg,
  onClick,
  text,
  subtext,
}: {
  svg: string;
  onClick: () => void;
  text: string;
  subtext: string;
}) => {
  return (
    <button
      type="button"
      className="flex w-full items-start gap-3 rounded-[4px] p-2 text-left hover:bg-grey-50"
      onClick={() => {
        onClick();
      }}
    >
      <Icon svg={svg} width={20} height={20} />

      <p className="flex flex-col text-sm">
        <span className="font-bold text-grey-950">{text}</span>
        <span className="text-grey-600">{subtext}</span>
      </p>
    </button>
  );
};

export const HelpWidget = ({
  helpWidgetRef,
  buttonClassName = "",
  closedButtonClassName = "!hidden md:!flex",
  variation = "primary",
  position = "top end",
  showMobileOverlay = true,
}: {
  helpWidgetRef: RefObject<HTMLButtonElement | null>;
  buttonClassName?: string;
  closedButtonClassName?: string;
  variation?: ButtonVariations;
  position?: "top end" | "bottom end";
  showMobileOverlay?: boolean;
}) => {
  const { width } = useWindowDimensions();

  return (
    <PopoverMenu
      customMenuItems={
        <div className="flex w-full flex-col">
          <HelpChannel
            svg="whatsapp"
            onClick={() => {
              sendWhatsappMessage();
            }}
            text="Send a WhatsApp Message"
            subtext="Get a response within minutes"
          />
          <HelpChannel
            svg="instagram"
            onClick={() => {
              const username = "usetikket";
              const instagramAppUrl = `instagram://user?username=${username}`;
              const instagramWebUrl = `https://ig.me/m/${username}`;

              if (width < 768) {
                // Attempt to open in app
                window.location.href = instagramAppUrl;
              } else {
                window.open(instagramWebUrl, "_blank");
              }
            }}
            text="Send an Instagram DM"
            subtext="Get a response within minutes"
          />

          <HelpChannel
            svg="mail"
            onClick={() => {
              sendSupportEmail();
            }}
            text="Send an email"
            subtext="Get a response within hours"
          />
        </div>
      }
      position={position}
      className="!w-fit"
      menuClassName="shadow-lg !w-[281px] !bg-white !p-1 !rounded-[8px]"
    >
      {({ open, close }) => {
        return (
          <>
            {open && showMobileOverlay && (
              <div className="fixed inset-0 bg-black/40 md:hidden" />
            )}
            <Button
              type="button"
              variation={variation}
              text={open ? "Close" : "Get Help"}
              icon={open ? "circle-close" : "circle-help"}
              className={`${!open ? closedButtonClassName : ""} !w-fit ${buttonClassName}`}
              ref={helpWidgetRef}
            />
          </>
        );
      }}
    </PopoverMenu>
  );
};
